import { c as _c } from "react/compiler-runtime";
import { UBLinkPath, useUdemyBusinessLink } from '@udemy-v2/organization-growth';
import { useClpCourse } from '@/features/course-landing-page/context/clp-course-provider.react-component';
interface UBCtaParams {
  ubHref: string;
  eventData: Record<string, string>;
}
export enum CtaPlacement {
  NON_PP_TRANSACTION = 'non-pp-transaction',
  DEFAULT = 'default',
}
export const useUbCtaParams = t0 => {
  const $ = _c(10);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    ctaPlacement: t2
  } = t1;
  const ctaPlacement = t2 === undefined ? CtaPlacement.DEFAULT : t2;
  const course = useClpCourse();
  const primaryCategory = course?.categories?.[0];
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      utm_source: "marketplace",
      utm_medium: "referral",
      utm_campaign: "mx-hooks",
      utm_content: "clp"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const eventData = t3;
  const t4 = `marketplace_${primaryCategory?.name ?? ""}`;
  let t5;
  if ($[3] !== ctaPlacement) {
    t5 = ctaPlacement === CtaPlacement.NON_PP_TRANSACTION ? eventData : {};
    $[3] = ctaPlacement;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t4 || $[6] !== t5) {
    t6 = {
      ref: t4,
      ...t5
    };
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const ubParams = t6;
  const ubHref = useUdemyBusinessLink(UBLinkPath.REQUEST_DEMO_MX, ubParams);
  let t7;
  if ($[8] !== ubHref) {
    t7 = {
      ubHref,
      eventData
    };
    $[8] = ubHref;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
};